import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import './i18n'

import { enableMocks } from 'app/mocks'

import App from 'app/App'

const Layout = () => (
    <BrowserRouter>
        <App />
    </BrowserRouter>
)

const rootElement = document.getElementById('root')

enableMocks().then(() => {
    ReactDOM.render(<Layout />, rootElement)
})
